import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AlreadyAuthenticatedGuard {
  constructor(private router: Router, private userService: UserService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    try {
      const user = await this.userService.getCurrentUser();

      if (user) {
        const redirect = route.queryParams['redirect'];
        if (redirect) {
          return this.router.parseUrl(redirect);
        }

        if (user.primary_role === 'CLIENT') {
          return this.router.createUrlTree(['/client']);
        } else {
          // ADMINISTRATOR, AGENT, CO-COUNSEL, etc.
          return this.router.createUrlTree(['/firm']);
        }
      }

      return true;
    } catch (error) {
      console.error('Error in AlreadyAuthenticatedGuard', error);
      this.userService.clearLocalSession();
      return true; // Allow access if error occurs (e.g. not logged in)
    }
  }
}
